import React from 'react';
import { cn } from '../utils';
export function Button({
  children,
  className,
  variant = 'primary',
  size = 'lg',
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
}) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-950';
  const variants = {
    primary: 'bg-brand-500 hover:bg-brand-600 text-white shadow-[0_8px_24px_rgba(201,85,139,0.28)] hover:shadow-[0_10px_32px_rgba(201,85,139,0.38)] focus:ring-brand-500',
    secondary: 'bg-lav-500 hover:bg-lav-600 text-white shadow-[0_8px_24px_rgba(139,107,184,0.28)] hover:shadow-[0_10px_32px_rgba(139,107,184,0.38)] focus:ring-lav-500',
    outline: 'border-2 border-brand-400 text-brand-600 bg-white hover:bg-brand-50 focus:ring-brand-500'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl md:text-2xl'
  };
  return <button className={cn(baseStyles, variants[variant], sizes[size], className)} {...props} data-id="element-278" data-mp="121z3jpf1i3sy">
      {children}
    </button>;
}
export function Badge({
  children,
  className,
  variant = 'default'
}: {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'success' | 'warning';
}) {
  const variants = {
    default: 'bg-white text-lav-700 border border-lav-200',
    success: 'bg-brand-100 text-brand-700 border border-brand-200',
    warning: 'bg-lav-100 text-lav-700 border border-lav-200'
  };
  return <span className={cn('inline-flex items-center px-3 py-1 rounded-full text-sm font-medium', variants[variant], className, 'text-[12px] pt-[1px] pb-[1px] pl-[1px] pr-[1px] flex-row items-center justify-center')} data-id="element-279" data-mp="s52rxatuh1k6">
      {children}
    </span>;
}
export function Card({
  children,
  className,
  glow = false
}: {
  children: React.ReactNode;
  className?: string;
  glow?: boolean;
}) {
  return <div className={cn('bg-white border border-lav-100 rounded-2xl p-6 md:p-8 shadow-[0_4px_20px_rgba(139,107,184,0.07)]', glow && 'box-glow border-brand-200', className)} data-id="element-280" data-mp="xztctk5xylz1">
      {children}
    </div>;
}